import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { updateMetaTags, MetaConfig } from '../utils/meta'
import Header from '../components/Header'

const tools = [
  {
    id: 'test-case',
    name: 'Test Case Generator',
    description: 'Generate comprehensive test cases from requirements using AI',
    path: '/test-case/',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.25">
        <rect x="3" y="2" width="10" height="12" rx="1.5" />
        <path d="M5.5 5.5h5M5.5 8h5M5.5 10.5h3" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'offers-audit',
    name: 'Offers Audit',
    description: 'Automated visual regression testing for promotional offers',
    path: '/offers-audit/',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.25">
        <circle cx="8" cy="8" r="5.5" />
        <circle cx="8" cy="8" r="2" />
        <path d="M8 2.5v1M8 12.5v1M2.5 8h1M12.5 8h1" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'risk-prioritization',
    name: 'Risk Prioritization',
    description: 'AI-powered test prioritization based on risk analysis',
    path: '/risk-prioritization/',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none">
        <path d="M3 12h2v2H3zM7 8h2v6H7zM11 4h2v10h-2z" fill="currentColor" />
      </svg>
    ),
  },
  {
    id: 'test-case-updater',
    name: 'Test Case Updater',
    description: 'Analyze test suites against sprint changes to find updates, gaps, and obsolete cases',
    path: '/test-case-updater/',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.25">
        <rect x="3" y="2" width="10" height="12" rx="1.5" />
        <path d="M5.5 5.5h5M5.5 8h3" strokeLinecap="round" />
        <path d="M10.5 9l-3 3v1h1l3-3z" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 'rt-audit',
    name: 'RT Audit',
    description: 'Automated Rent-a-Toyota dealership website compliance audit',
    path: '/rt-audit/',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.25">
        <rect x="2" y="3" width="12" height="10" rx="1.5" />
        <path d="M2 6h12M5 6v7" strokeLinecap="round" />
        <path d="M7.5 8.5l1.5 1.5 3-3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
]

export default function LandingPage() {
  useEffect(() => {
    updateMetaTags(MetaConfig.homepage.title, MetaConfig.homepage.description, window.location.href)
  }, [])

  return (
    <div className="min-h-screen bg-linear-bg">
      <Header />

      {/* Main Content */}
      <div className="flex flex-col items-center px-6 py-16">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h1 className="text-[24px] font-medium text-linear-text mb-3">
            QA Tools
          </h1>
          <p className="text-[15px] text-linear-text-muted max-w-md">
            AI-powered testing tools for modern QA workflows
          </p>
        </div>

        {/* Tools List - Linear style */}
        <div className="w-full max-w-lg">
          <div className="bg-linear-bg-card border border-linear-border-input rounded-lg overflow-hidden">
            {tools.map((tool, index) => (
              <Link
                key={tool.id}
                to={tool.path}
                className={`
                  flex items-center gap-4 px-5 py-4
                  transition-colors duration-75
                  hover:bg-linear-text-muted/10
                  ${index !== tools.length - 1 ? 'border-b border-linear-border' : ''}
                `}
              >
                <div className="w-8 h-8 bg-linear-bg-hover rounded-lg flex items-center justify-center flex-shrink-0 text-linear-text-muted">
                  {tool.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-[13px] font-medium text-linear-text">
                    {tool.name}
                  </h3>
                  <p className="text-[12px] text-linear-text-muted truncate">
                    {tool.description}
                  </p>
                </div>
                <svg
                  className="w-4 h-4 text-linear-text-placeholder flex-shrink-0"
                  viewBox="0 0 16 16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M6 4l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12">
          <p className="text-[11px] text-linear-text-placeholder">Five & Done Internal Tool</p>
        </div>
      </div>
    </div>
  )
}
